module.exports = {
      id: "thailand-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#thailand-usage",
      toString: function () {
        return this.url;
      }
    }